export default __webpack_public_path__ + "static/media/PlayIconWhite.44b7e00d.svg";